var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (2==2)?_c('div',[(_vm.temImagem)?_c('div',[_c('img',{attrs:{"src":_vm.imagem,"alt":""},on:{"error":_vm.onErrorImagem}})]):_vm._e(),_c('div',{staticClass:"overlay"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }